import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { CampaignMeta } from '../../types/campaignReport';
import { formatCurrencyGBP, parseNumber } from '../../lib/reportFormatters';
import { MapPin, Clock, Package, DollarSign } from 'lucide-react';

interface ReportHeaderProps {
  campaignName: string;
  meta: CampaignMeta;
}

export function ReportHeader({ campaignName, meta }: ReportHeaderProps) {
  const asp = parseNumber(meta.price);
  
  return (
    <Card 
      className="mb-8 overflow-hidden"
      style={{ 
        boxShadow: '0 4px 6px -1px rgba(24, 61, 247, 0.3), 0 2px 4px -1px rgba(24, 61, 247, 0.18)',
        background: 'linear-gradient(135deg, rgba(24, 61, 247, 0.03) 0%, rgba(24, 61, 247, 0.08) 100%)'
      }}
    >
      <CardContent className="p-6 md:p-8">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          {/* Left: Campaign Name + Subtitle */}
          <div className="flex-1">
            <h1 className="text-3xl md:text-4xl font-bold mb-3" style={{ color: '#183df7' }}>
              {campaignName}
            </h1>
            <div className="flex flex-wrap items-center gap-4 text-sm text-muted-foreground">
              {meta.location && (
                <div className="flex items-center gap-2">
                  <MapPin className="w-4 h-4" style={{ color: '#183df7' }} />
                  <span>{meta.location}</span>
                </div>
              )}
              {meta.duration && (
                <div className="flex items-center gap-2">
                  <Clock className="w-4 h-4" style={{ color: '#183df7' }} />
                  <span>{meta.duration}</span>
                </div>
              )}
              {meta.product && (
                <div className="flex items-center gap-2">
                  <Package className="w-4 h-4" style={{ color: '#183df7' }} />
                  <span>{meta.product}</span>
                </div>
              )}
              {meta.price && (
                <div className="flex items-center gap-2">
                  <DollarSign className="w-4 h-4" style={{ color: '#183df7' }} />
                  <span>{meta.price}</span>
                </div>
              )}
            </div>
          </div>
          
          {/* Right: Badge Stack */}
          <div className="flex flex-wrap gap-2 md:justify-end">
            {meta.location && (
              <Badge variant="secondary" className="px-3 py-1.5 text-sm font-medium">
                <MapPin className="w-3 h-3 mr-1.5" />
                {meta.location.split(',')[0]}
              </Badge>
            )}
            {meta.duration && (
              <Badge variant="secondary" className="px-3 py-1.5 text-sm font-medium">
                <Clock className="w-3 h-3 mr-1.5" />
                {meta.duration}
              </Badge>
            )}
            {asp > 0 && (
              <Badge variant="secondary" className="px-3 py-1.5 text-sm font-medium">
                <DollarSign className="w-3 h-3 mr-1.5" />
                ASP: {formatCurrencyGBP(asp)}
              </Badge>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
